<template>
  <div class="d-flex flex-column">
    <talk-file-upload ref="fileUpload" :filename="filename" :set-handler="setUploadFileHandler" :is-invalid="errorMessage"
      @delete="$emit('delete')" />
  </div>
</template>
<script>
import TalkFileUpload from "@/views/atoms/inputs/TalkFileUpload";

export default {
  name: "UploadTalkFile",
  components: {
    TalkFileUpload,
  },
  emits: ['delete'],
  inject: [
    '$constant',
  ],
  props: {
    issues: {
      type: Array,
      default: () => [],
    },
    filename: {
      type: String,
      default: '',
    },
    setUploadFileHandler: {
      type: Function,
      default: () => { },
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
}
</script>
